/**
 * Unico modulo do apidocs. Sem `permissao` declarada de proposito: quem
 * chegou aqui ja passou pelo gate de verdade, o `service_proprio`
 * `hliberty.apidocs` que decide se a aplicacao aparece no menu do admin (ver
 * AppRegistrySeeder em liberty/apps/auth) -- igual ao /perfil do accounts,
 * nao ha necessidade de uma segunda permissao fina aqui dentro.
 */
export const nav = {
    section: '',
    title: 'Documentacao',
    icon: 'menu_book',
    route: '/documentacao',
    accordion: false,
};

export default [
    {
        path: '/documentacao',
        name: 'documentacao',
        component: () => import('./pages/DocumentacaoIndexPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/documentacao/pacotes/:pacote',
        name: 'documentacao-pacote',
        component: () => import('./pages/PacoteDocPage.vue'),
        props: true,
        meta: { requiresAuth: true },
    },
    {
        path: '/documentacao/guias/sso',
        name: 'documentacao-guia-sso',
        component: () => import('./pages/guias/GuiaSsoPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/documentacao/guias/construcao',
        name: 'documentacao-guia-construcao',
        component: () => import('./pages/guias/GuiaConstrucaoPage.vue'),
        meta: { requiresAuth: true },
    },
];
